(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-brand-tab"
      }, [_vm.faqText ? _c('div', {
        staticClass: "nx-faq",
        on: {
          "click": _vm.goFaq
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.faqText))])]) : _vm._e(), _vm.brandType ? _c('div', {
        staticClass: "nx-logo",
        class: _vm.classType
      }, [_c('img', {
        attrs: {
          "src": _vm.brandLogo || _vm.imgObj[_vm.brandType],
          "alt": "品牌商标"
        }
      })]) : _vm._e()]);
    },
    name: 'nx-brand-footer',
    props: {
      brandType: {
        type: String,
        default: ''
      },
      faqText: {
        type: String,
        default: ''
      },
      faqUrl: String,
      brandLogo: String
    },
    data: function data() {
      return {
        imgObj: {
          normal: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/a94a38f0-0c1e-11ee-bdfc-5f15dc269fac.png',
          finance: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/a94a38f0-0c1e-11ee-bdfc-5f15dc269fac.png',
          normalDark: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/dfbc1580-0b87-11ee-8af8-0311b199d914.png',
          financeDark: 'https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/dfbc1580-0b87-11ee-8af8-0311b199d914.png'
        },
        brandSrcKey: ''
      };
    },
    created: function created() {
      var nxThemeOff = document.documentElement && document.documentElement.getAttribute('data-nx-theme') === 'off';
      var isDarkMode = !nxThemeOff && window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.brandType = this.brandType || this.faqText ? this.brandType : 'normal';
      this.brandSrcKey = isDarkMode ? "".concat(this.brandType, "Dark") : this.brandType;
    },
    computed: {
      classType: function classType() {
        return this.faqText && this.brandType ? 'nx-logo-margin' : '';
      }
    },
    methods: {
      goFaq: function goFaq() {
        this.$emit('click');

        if (!this.faqUrl) {
          return;
        }

        window.location.href = this.faqUrl;
      }
    }
  };
  _exports.default = _default;
});